export default __webpack_public_path__ + "static/media/post-img-1.759d4eb8.png";